/**
 * 监听器
 * 内部使用TinyEmitter实例实现，增加了类型支持
 */
import { TinyEmitter } from 'tiny-emitter';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
type Events = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [eventName: string]: any;
};

class EventBus<E extends Events> {
  emitter: TinyEmitter;

  constructor() {
    this.emitter = new TinyEmitter();
  }

  /**
   * 处理触发监听的事件
   * @param eventName 事件名称
   * @param params 响应函数的参数
   */
  emit<K extends Extract<keyof E, string>>(eventName: K, params: E[K]): void {
    this.emitter.emit(eventName, params);
  }

  /**
   * 添加绑定的监听事件
   * @param eventName 事件名称
   * @param callback 响应的函数
   */
  async on<K extends Extract<keyof E, string>>(
    eventName: K,
    callback: (v: E[K]) => void | Promise<void>,
  ): Promise<void> {
    this.emitter.on(eventName, callback);
  }

  /**
   * 添加绑定的监听事件
   * @param eventName 事件名称
   * @param callback 响应的函数
   */
  once<K extends Extract<keyof E, string>>(
    eventName: K,
    callback: (v: E[K]) => void | Promise<void>,
  ): void {
    this.emitter.once(eventName, callback);
  }

  /**
   * 添加绑定的监听事件
   * @param eventName 事件名称
   * @param callback 响应的函数
   */
  off<K extends Extract<keyof E, string>>(
    eventName: K,
    callback: (v: E[K]) => void | Promise<void>,
  ): void {
    this.emitter.off(eventName, callback);
  }
}

export default EventBus;
